@if (currentTaskflowViewType == taskflowViewType.Salesflow) {
	@if (taskflowContainOpenTasks()) {
		<view-salesflow [taskflowId]="taskflowId" (selectedActionIdChange)="selectedActionId = $event" />
	}
	@else {
		<panel>
			<closed-salesflow [taskflow]="taskflow" />
		</panel>
	}
}
@if (currentTaskflowViewType == taskflowViewType.Default && taskflow) {
	<default-taskflow [taskflow]="taskflow" [(selectedActionId)]="selectedActionId" />
}
